import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SurveyManageUsersForm from "components/Forms/SurveyManageUsersForm/SurveyManageUsersForm";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { getIdentificationTypes } from "app/features/surveySlice";
import { savePerson, hidePersonToast, clearPersonResponse, clearPersonError } from "app/features/personSlice";
import { SurveyPerson } from "types";
import { getContriesArea } from "app/features/placesSlice";
import FormCard from "components/Forms/FormCard/FormCard";
import withAuth from "lib/hoc/withAuth";
import { getToastMessage } from "lib/helpers/toastMessageHelper";
import NewToast from "ui/atoms/NewToast";

const UserSurveyCreate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onCreateSurveyUser = async (surveyUser: SurveyPerson) => {
    const response = (await dispatch(savePerson(surveyUser))) as any;
    if (response?.error?.message === "Rejected") {
      return;
    }
    setTimeout(() => {
      navigate("/survey/send", { replace: false });
    }, 800);
  };

  const { personError, personLoading, personResponse, personShowToast, personSeverity } = useAppSelector(
    (state) => state.person
  );
  const { identificationTypes } = useAppSelector((state) => state.survey);
  const { countryCodes } = useAppSelector((state) => state.places);

  const clearToast = () => {
    dispatch(hidePersonToast());
    dispatch(clearPersonResponse());
    dispatch(clearPersonError());
  };

  useEffect(() => {
    dispatch(getIdentificationTypes());
    dispatch(getContriesArea());
    return () => {
      clearToast();
    };
  }, []);
  return (
    <>
      <NewToast open={personShowToast} setOpen={clearToast} severity={personSeverity}>
        {getToastMessage(personResponse, personError)}
      </NewToast>
      <FormCard maxWidthCard={775} maxWidthContainer='md' title='Crear Encuestado'>
        <SurveyManageUsersForm
          create
          loading={personLoading}
          handleSubmit={onCreateSurveyUser}
          submitButtonText='Crear usuario'
          identificationTypes={identificationTypes}
          countryCodes={countryCodes}
        />
      </FormCard>
    </>
  );
};

export default withAuth(UserSurveyCreate);
